"use client";

import { useEffect } from "react";
import { persistFirstTouch } from "@/lib/acquisition";

export function AnalyticsBridge() {
  useEffect(() => {
    persistFirstTouch();
  }, []);

  return null;
}
